export function formatRelativeEventTime(value, nowMs = Date.now()) {
  const time = new Date(value).getTime();
  if (!Number.isFinite(time)) return "now";
  const diffSeconds = Math.max(0, Math.floor((nowMs - time) / 1000));
  if (diffSeconds < 60) return "now";
  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  const diffHours = Math.floor(diffMinutes / 60);
  return `${diffHours}h ago`;
}
